import _ from 'lodash';
import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
import DirectusService from '@/core/directus/directus.service';
import LanguageCode from '@/locale/language-code';
import { IApplicationCenter } from '@/shared/model/travelpurpose/application-center.model';
import SchengenService from '@/visa-application/services/schengen/schengen.service';
import VisaSubtypeSelection from '@/visa-application/applier-visa-subtype/visa-subtype-selection/visa-subtype-selection.vue';
import TravelPurposeCMSModel from '@/visa-application/models/TravelPurposeCMSModel';
import { ALL_COUNTRY_CODE, BEVOW_WORKFLOW_INTEGRATION_ISSUERS, ISSUER_REDIRECT_TOKEN } from '@/constants';
import { getCmsDataByCountryAndDefault, replaceAllOccurrenceOfADetailCode } from '@/shared/utils/utils';
import LoginService from '@/account/login.service';

@Component({
  components: {
    'visa-subtype-selection': VisaSubtypeSelection
  }
})
export default class ApplierVisaSubtype extends Vue {
  public travelPurposeCmsData: TravelPurposeCMSModel = new TravelPurposeCMSModel();
  public applicationCenter: IApplicationCenter = {};
  public residenceCountryCode = '';
  public issuer = '';
  public currentLanguage: LanguageCode = this.$store.getters.currentLanguage;

  @Inject('schengenService')
  private schengenService: () => SchengenService;
  @Inject('directusService')
  private directusService: () => DirectusService;
  @Inject('loginService')
  private loginService: () => LoginService;

  public get isRegistrationEnabled(): boolean {
    return !BEVOW_WORKFLOW_INTEGRATION_ISSUERS.includes(this.issuer);
  }

  public beforeRouteEnter(to, from, next) {
    next(vm => {
      if (to.params.issuer) {
        vm.residenceCountryCode = to.params.residenceCountryCode;
        vm.issuer = to.params.issuer;
        vm.getContent(vm.currentLanguage);
      }
    });
  }

  @Watch('$store.getters.currentLanguage', { deep: true })
  public onLanguageChange(language: LanguageCode) {
    this.currentLanguage = language;
    this.getContent(language);
  }

  public openRegister() {
    this.loginService().goToRegister(this.residenceCountryCode, this.issuer);
  }

  public getContent(currentLanguage: LanguageCode): void {
    const filter = {
      'country.code': {
        in: [this.residenceCountryCode, ALL_COUNTRY_CODE]
      }
    };

    this.directusService()
      .getCollection<TravelPurposeCMSModel>(TravelPurposeCMSModel, 'travel_purpose', ['*.*'], filter, currentLanguage)
      .then((response: TravelPurposeCMSModel[]) => {
        this.travelPurposeCmsData = getCmsDataByCountryAndDefault(response, this.residenceCountryCode);
        this.$store.commit('metaInfo', this.travelPurposeCmsData);
      })
      .catch(error => console.error(error));
  }
}
